export const EducationCard = ({ name, img, link }) => {
  return (
    <div className="col-md-4">
      <a href={link} target="_blank" rel="noreferrer" className="thumbnail">
        <img src={img} alt={name} className="team-img" />
        <div className="caption">
          <h4>{name}</h4>
        </div>
      </a>
    </div>
  );
};
